
const invokes = {}
let invokeId = 1

function removeInvoke(invoke) {
  window[invoke.callback] = null;
  if(invoke.iframe){
    document.body.removeChild(invoke.iframe);
  }
  delete invokes[invoke.callback];
}

function invokeNative(func, params, onSuccess, onError) {
  const invoke = {
    func: func,
    callback: "uniwebToNativeCallback" + invokeId,
    params: params
  };
  const iframe = document.createElement("iframe");
  iframe.src = "uniweb://" + encodeURIComponent(JSON.stringify(invoke));
  iframe.className = "native-iframe";
  invoke.iframe = iframe;
  invokes[invoke.callback] = invoke;
  window[invoke.callback] = function (res) {
    if (res && res.errno) {
      console.log(res);
      onError && onError(res);
    } else {
      onSuccess && onSuccess(res);
    }
    removeInvoke(invoke);
  };
  setTimeout(() => {
    // document.body.removeChild(invoke.iframe);
    invoke.iframe = null;
  }, 1000);
  document.body.appendChild(iframe);
  invokeId++;
}

export function playGameMusic(){
  invokeNative('playGameMusic')
}

export function stopGameMusic(){
  invokeNative('stopGameMusic')
}


export default invokeNative;



// WEBPACK FOOTER //
// ./src/common/invokeNative.js